
import React from "react"
import styled from 'styled-components';
import { NavLink } from 'react-router-dom';
import { redirect } from "react-router-dom";

const MenuElement = styled(NavLink)`
&:hover {
    color: ${props => props.theme.colors.contraste};
  }
&.active {
    color: ${props => props.theme.colors.texte_menu};
}
text-decoration: none;
color:${props => props.theme.colors.dark};
margin: 5px 20px;
cursor:pointer;
display: inline-block;
`

const MenuBar = styled.div`
background-color:${props => props.theme.colors.fond_menu};
width:100%;
text-align: center;
margin: 5px 0px 5px 0px;
padding:25px 0px 25px 0px;
`

const Login = styled.div`
padding: 2px;
margin: 5px;
width:100%;
text-align:right;
`

const  NavBar= () => {

    const verification = () => {
        const dateValiditeJeton = new Date(localStorage.getItem('date_expired'))
        if  (localStorage.getItem('email') && (dateValiditeJeton > Date.now())){
            return true
        } else {
            localStorage.clear()
            return false
        }
    }
    const connecte = verification()

    const identite = () => {
        if  (connecte){
            return (<span>Connecté en tant que {localStorage.getItem('email')}</span>)
        }
        return
    }

    const logout = () => {
        localStorage.clear()
        redirect("/");
    }

    return (
        <>

        <MenuBar>
            <MenuElement reloadDocument to="/">Accueil</MenuElement>
            <MenuElement reloadDocument to="/inscription">Inscription</MenuElement>
            <MenuElement reloadDocument to="/document">Archive&nbsp;physique</MenuElement>
            <MenuElement reloadDocument to="/donnee">Donnée&nbsp;numérique</MenuElement>
            <MenuElement reloadDocument to="/auteur">Auteur&nbsp;Contributeur</MenuElement>
            <MenuElement reloadDocument to="/collection">Collection</MenuElement>
        </MenuBar>
        <Login>
            {identite()}
            {! connecte &&  <MenuElement reloadDocument to="/login">(Se connecter) </MenuElement> }
            {connecte && <MenuElement reloadDocument onClick={logout}>(Se déconnecter)</MenuElement> }
        </Login>
        </>

    );
}

export default NavBar;